import React from 'react';
import { jugadoresEnPista, etiquetaWo as textoWo } from '../utils/jornadasUtils';
import { nombreVisible } from '../utils/jugadores';

const fechaCorta = (iso) => String(iso).slice(0, 10).split('-').reverse().join('/');

const NUM_SETS = 3;

const capitalize = (s) => s.charAt(0) + s.slice(1).toLowerCase();

// Tarjeta de un partido para las páginas de Jornadas (pública y privada):
// cabecera con equipos/puntos de clasificación + desglose de puntos por
// set, todo estático (sin inputs, botones ni estado de confirmación --
// para eso está Actas).
const PartidoJornada = ({ partido, pista, sede }) => {
    // sets_local/sets_visitante son los sets ganados (0-2, como en Actas);
    // clasif_local/clasif_visitante son los puntos de ranking del baremo
    // (p. ej. 3-1), que no pintan nada en la cabecera de un partido.
    const pL = partido.estado === 'CONFIRMADO' ? Number(partido.sets_local) : null;
    const pV = partido.estado === 'CONFIRMADO' ? Number(partido.sets_visitante) : null;
    const hayResultado = pL != null && pV != null;
    const enPista = jugadoresEnPista(partido.modalidad);
    const haySets = partido.sets && partido.sets.length > 0;
    // aplazado_lado solo llega si lo pidió un lado concreto (no lesión ni ambos).
    const quienAplaza = partido.estado === 'APLAZADO' && partido.aplazado_lado
        ? (partido.aplazado_lado === 'LOCAL' ? partido.local_nombre : partido.visitante_nombre)
        : null;

    // El ausente es el rival del ganador (ganador_participante_id solo llega confirmado).
    const etiquetaWo = textoWo(partido);
    const ausente = etiquetaWo && partido.ganador_participante_id != null
        ? (Number(partido.ganador_participante_id) === Number(partido.local_participante_id)
            ? partido.visitante_nombre : partido.local_nombre)
        : null;

    return (
        <div className="partido">
            <div className="partido-cabecera">
                <span className="modalidad-badge">
                    {capitalize(partido.modalidad)}{partido.tipo ? ` · ${partido.tipo}` : ''}
                </span>
                {pista && (
                    <span className="partido-pista">
                        {pista.hora} h · Pista {pista.pista}
                        {sede && <span className="partido-sede">{sede}</span>}
                    </span>
                )}
            </div>
            {partido.estado === 'APLAZADO' && (
                <div className="partido-estado">
                    <span className="etiqueta-aplazado">
                        Aplazado{partido.fecha_reprogramada ? ` · ${fechaCorta(partido.fecha_reprogramada)}` : ''}
                    </span>
                    {partido.aplazado_justificado && !partido.fecha_reprogramada && (
                        <span className="etiqueta-pendiente-reprogramacion">pendiente reprogramación</span>
                    )}
                </div>
            )}
            <div className="partido-fila">
                <div className="equipo local">
                    <div className="nombre-equipo">{partido.local_nombre}</div>
                </div>
                <div className="marcador">
                    {hayResultado ? (
                        <>
                            <span className={`puntos${pL > pV ? ' ganador' : ''}`}>{pL}</span>
                            <span className="separador">-</span>
                            <span className={`puntos${pV > pL ? ' ganador' : ''}`}>{pV}</span>
                        </>
                    ) : (
                        <span className="pendiente">
                            {partido.estado === 'APLAZADO' ? 'Aplazado' : 'vs'}
                        </span>
                    )}
                </div>
                <div className="equipo visitante">
                    <div className="nombre-equipo">{partido.visitante_nombre}</div>
                </div>
            </div>

            {etiquetaWo && (
                <div className="partido-wo">{etiquetaWo}{ausente ? ` · no se presenta ${ausente}` : ''}</div>
            )}

            {partido.arrastradoDe && (
                <div className="partido-aplazado">Aplazado de la jornada {partido.arrastradoDe}</div>
            )}

            {quienAplaza && !partido.aplazado_justificado && (
                <div className="partido-aplazado">Aplazado por {quienAplaza}</div>
            )}

            {haySets && (
                <div className="partido-sets">
                    {Array.from({ length: NUM_SETS }, (_, i) => {
                        const set = partido.sets.find((s) => s.numero === i + 1);
                        if (!set) return null;
                        const jugadorLocal = i < enPista ? partido.alineacion_local[i] : null;
                        const jugadorVisitante = i < enPista ? partido.alineacion_visitante[i] : null;

                        return (
                            <div key={i} className="partido-set-fila">
                                <span className="partido-set-jugador partido-set-jugador-local">
                                    {nombreVisible(jugadorLocal)}
                                </span>
                                <span className="partido-set-puntos">
                                    {set.puntosLocal}-{set.puntosVisitante}
                                </span>
                                <span className="partido-set-jugador partido-set-jugador-visitante">
                                    {nombreVisible(jugadorVisitante)}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default PartidoJornada;
